export function showBack(state) {
  state.back.show = true
}
export function hideBack(state) {
  state.back.show = false
}
export function setShowMap(state, showMap) {
  state.showMap = !!showMap
}
